import {Alert, AlertDescription, AlertIcon, AlertTitle} from '@chakra-ui/react';

import {QuestionProps} from './question';

export function UnsupportedQuestion(props: Readonly<QuestionProps>) {
  return (
    <Alert status='error'>
      <AlertIcon />
      <AlertTitle>Pregunta no soportada</AlertTitle>
      <AlertDescription>
        La pregunta no es compatible con este tipo de formularios.
        <br />
        {props.question.dataType}
      </AlertDescription>
    </Alert>
  );
}
